import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckBladderSizeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-bladder-size-slot',
    templateUrl: './check-bladder-size-slot.component.html',
    styleUrl: './check-bladder-size-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBladderSizeSlotComponent implements SheetSlotComponentBase {

	@Input() action!: CheckBladderSizeAction;
	value = null;

	constructor() {
	}
}